import { WorkawareApi } from 'apis/WorkawareApi'
import { RoleModel, RoleModuleAccessModel } from 'data/models'

export interface RoleUpsertPayload {
  RoleName: string
  Description?: string | null
  IsAdminLike: boolean
  IsManagerLike: boolean
}

export class roleService {
  private _api: WorkawareApi

  constructor(api: WorkawareApi) {
    this._api = api
  }

  getRoles = (): Promise<RoleModel[]> => {
    return this._api.roles.list() as Promise<RoleModel[]>
  }

  createRole = (payload: RoleUpsertPayload): Promise<RoleModel> => {
    return this._api.roles.create(payload) as Promise<RoleModel>
  }

  updateRole = (id: number, payload: RoleUpsertPayload): Promise<RoleModel> => {
    return this._api.roles.update(id, payload) as Promise<RoleModel>
  }

  deleteRole = (id: number, reassignToRoleId?: number | null): Promise<{ success: boolean; reassignedUserCount: number }> => {
    return this._api.roles.delete(id, { ReassignToRoleId: reassignToRoleId ?? null }) as Promise<any>
  }

  getModuleAccess = (id: number): Promise<RoleModuleAccessModel[]> => {
    return this._api.roles.getModuleAccess(id) as Promise<RoleModuleAccessModel[]>
  }

  updateModuleAccess = (id: number, items: RoleModuleAccessModel[]): Promise<RoleModuleAccessModel[]> => {
    return this._api.roles.updateModuleAccess(id, { Items: items }) as Promise<RoleModuleAccessModel[]>
  }
}
